import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/shared/Login';
import EmployeeLogin from './components/employee/EmployeeLogin';
import LandingPage from './components/shared/LandingPage';

import EmployeeDashboard from './components/employee/EmployeeDashboard';
import Leaderboard from './components/employee/Leaderboard';
import Contests from './components/employee/Contests';
import RewardsStore from './components/employee/RewardsStore';
import Profile from './components/employee/Profile';
import AttendancePage from './components/employee/AttendancePage';
import FuelSalesPage from './components/employee/FuelSalesPage';
import FuelEntryPage from './components/employee/FuelEntryPage';
import AdminDashboard from './components/admin/AdminDashboard';
import AdminNavbar from './components/admin/AdminNavbar';
import EmployeeMenu from './components/employee/EmployeeMenu';
import BottomNav from './components/employee/BottomNav';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is logged in
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    
    if (token && userData) {
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  };

  if (loading) {
    return <div className="flex justify-center items-center h-screen">Loading...</div>;
  }

  return (
    <Router>
      <div className="App">
  {user && (user.role === 'employee' ? <EmployeeMenu user={user} onLogout={handleLogout} /> : <AdminNavbar user={user} onLogout={handleLogout} />)}
        {/* reserve bottom space so content doesn't hide under bottom nav on small screens */}
        <div className="pb-20 sm:pb-0">
        <Routes>
          <Route 
            path="/" 
            element={!user ? <EmployeeLogin onLogin={handleLogin} /> : (user.role === 'employee' ? <Navigate to="/employee" /> : <Navigate to="/admin" />)} 
          />
          <Route 
            path="/employee" 
            element={user && user.role === 'employee' ? <EmployeeDashboard user={user} /> : <Navigate to="/employee-login" />} 
          />
          <Route
            path="/employee/leaderboard"
            element={user && user.role === 'employee' ? <Leaderboard user={user} /> : <Navigate to="/employee-login" />}
          />
          <Route
            path="/employee/contests"
            element={user && user.role === 'employee' ? <Contests /> : <Navigate to="/employee-login" />}
          />
          <Route
            path="/employee/attendance"
            element={user && user.role === 'employee' ? <AttendancePage user={user} /> : <Navigate to="/employee-login" />}
          />
          <Route
            path="/employee/fuel-sales"
            element={user && user.role === 'employee' ? <FuelSalesPage user={user} /> : <Navigate to="/employee-login" />}
          />
          <Route
            path="/employee/entry"
            element={user && user.role === 'employee' ? <FuelEntryPage user={user} /> : <Navigate to="/employee-login" />}
          />
          <Route
            path="/employee/rewards"
            element={user && user.role === 'employee' ? <RewardsStore user={user} /> : <Navigate to="/employee-login" />}
          />
          <Route
            path="/employee/profile"
            element={user && user.role === 'employee' ? <Profile user={user} /> : <Navigate to="/employee-login" />}
          />
          <Route 
            path="/admin" 
            element={user && user.role === 'admin' ? <AdminDashboard user={user} /> : <Navigate to="/login" />} 
          />
          <Route 
            path="/login" 
            element={!user ? <Login onLogin={handleLogin} /> : <Navigate to="/admin" />} 
          />
          <Route 
            path="/employee-login" 
            element={!user ? <EmployeeLogin onLogin={handleLogin} /> : <Navigate to="/employee" />} 
          />
          <Route 
            path="/landing" 
            element={!user ? <LandingPage /> : (user.role === 'employee' ? <Navigate to="/employee" /> : <Navigate to="/admin" />)} 
          />
        </Routes>
        </div>
        {user && user.role === 'employee' && <BottomNav user={user} />}
      </div>
    </Router>
  );
}

export default App;